import ArticleCard from './article-card';

export default ArticleCard;